import { Component, HostListener, inject } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  templateUrl: './bary-modal-result.component.html',
  styleUrls: ['./bary-modal-result.component.scss'],
})
export class BaryModalResultComponent {
  readonly modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public message?: string;
  public icon?: string;

  public buttons = {
    first: '',
    second: '',
  };
  public class = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
